import {
  Button,
  Icon,
  Menu as ChakraMenu,
  MenuButton,
  MenuItem,
  MenuList,
  Flex,
} from '@chakra-ui/react';
import { ChevronDownIcon } from '@heroicons/react/solid';
import { FaCheck } from 'react-icons/fa6';
import { KText } from '@/ui-library/components/text';
// import { useEffect } from 'react';

export const VisibleMenu = ({
  menuItems,
  handleActionClick,
  leftIcon,
  menuButtonLabel,
  placement,
  menuButtonProps,
  selectedItem,
}) => {
  return (
    <ChakraMenu placement={placement}>
      <MenuButton
        as={Button}
        leftIcon={leftIcon && <Icon as={leftIcon} color="ats-primary" />}
        rightIcon={
          <Icon
            width="16px"
            height="unset"
            as={ChevronDownIcon}
            color="secondary-700"
          />
        }
        variant="secondary"
        maxH="34px"
        px="12px"
        boxShadow="0px 1px 2px 0px #1018280D"
        {...menuButtonProps}
      >
        {selectedItem?.component ? (
          <selectedItem.component />
        ) : (
          <KText size="sm-regular" color="secondary-900">
            <Flex gap="6px" alignItems="center">
              <Icon
                color="primary-900"
                className="primary-900"
                w="16px"
                h="16px"
                as={selectedItem?.icon}
              ></Icon>
              {menuButtonLabel}
              <KText size="sm-medium" color="secondary-900" as="span">
                {selectedItem?.label}
              </KText>
            </Flex>
          </KText>
        )}
      </MenuButton>
      <MenuList zIndex="9">
        {menuItems?.map((item) => {
          const { iconProps, id, label, icon, onClick, Comp, description } =
            item;
          return (
            <MenuItem
              key={id}
              gap="8px"
              bg={selectedItem?.id === item.id ? 'ats-tertiary' : 'inherit'}
              _hover={{ bg: 'secondary-25' }}
              _active={{ bg: 'secondary-25' }}
              borderRadius={'5px'}
              onClick={() => {
                onClick?.(item);
                handleActionClick?.(item);
              }}
            >
              {Comp ? (
                <Comp />
              ) : (
                <>
                  <Flex
                    justifyContent={'space-between'}
                    alignItems={'center'}
                    gap="8px"
                    position={'relative'}
                  >
                    <Flex>
                      {icon && (
                        <Icon
                          as={icon}
                          width="16px"
                          height="16px"
                          color="primary-900"
                          className="primary-900"
                          {...iconProps}
                        />
                      )}
                    </Flex>
                    <Flex minW={'260px'} position={'relative'} flexDir="column">
                      <KText size="sm-medium" color="secondary-900">
                        {label}
                      </KText>
                      <KText size="xs-regular" color="secondary-700">
                        {description}
                      </KText>
                    </Flex>
                    {selectedItem?.id === item.id && (
                      <Icon
                        position={'absolute'}
                        top="10px"
                        right="10px"
                        as={FaCheck}
                        width="16px"
                        height="16px"
                        color="primary-900"
                        className="primary-900"
                      />
                    )}
                  </Flex>
                </>
              )}
            </MenuItem>
          );
        })}
      </MenuList>
    </ChakraMenu>
  );
};
